module.exports = "/assets/f1310667facf5bb5792530272e2e5fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HV.png
// module id = 1453
// module chunks = 0